import { gql } from '@apollo/client';

export default gql`
  {
    Producers {
        IdProductor
        Productor
    }
  }
`;